import { render } from "./AuditLog.vue?vue&type=template&id=270cbe03&ts=true"
import script from "./AuditLog.vue?vue&type=script&lang=ts"
export * from "./AuditLog.vue?vue&type=script&lang=ts"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__